import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthRoute from "./routes/AuthRoute";
import GuestRoutes from "./routes/GuestRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const navigate = useNavigate();
  const admin = useSelector((state) => state.admin.txtconnect_ng_admin);
  const token = useSelector((state) => state.admin.token);
  //COMM
  useEffect(() => {
    if (admin && token && window.location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [admin, token, navigate]);

  return (
    <>
      {admin && token ? <AuthRoute /> : <GuestRoutes />}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
